import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { useUserSettingsAcriss } from "../../@hooks"


export default function UserSettingsAcrissTabButton() {

    const { handleSetAcrissFormData } = useUserSettingsAcriss()

    return <ButtonLoadingSeeker
        startIcon={<IconSeeker icon="add" />}
        onClick={handleSetAcrissFormData}
    >
        Define ACRISS Color
    </ButtonLoadingSeeker>
}